import { Navigate, Route, Routes } from 'react-router-dom';
import './App.css';
import MainLayout from 'components/layouts/MainLayout';
import { mainRoutes } from 'apis/routes/routes';
import PrivateRoute from 'apis/routes/AuthRoute';
import styles from './app.style';
import { useEffect, useRef } from 'react';
import ToastRoot from 'components/ToastAlert';
import { RootState, useAppDispatch, useAppSelector } from 'cache/store';
import authApi from 'apis/authApi';
import { cacheUserInfo, login, logout } from 'features/authSlice';
import MessageAlertCustom from 'components/alert-message/MessageAlertCustom';
import MiniGameIcon from 'components/minigame/MiniGameIcon';
import { cacheUrlCDN } from 'features/configSlice';
import { isMobile } from 'react-device-detect';
import SupportArea from 'components/support-area/SupportArea';
import alertMsg from 'components/alert-message/alert-message';
import { UserInfoModel } from 'models/userInfoModel';
import Register from 'pages/register/Register';
let timeoutId: any;

const App = () => {
    const rootDivRef = useRef<HTMLDivElement>(null);
    const dispatch = useAppDispatch();
    const { isLogged } = useAppSelector((state: RootState) => state.auth);
    const stopRequestUserInfo = useRef<boolean>(false);
    const isLoggedRef = useRef<boolean>(false);

    useEffect(() => {
        const urlCdn = process.env.VITE_API_URL;
        dispatch(cacheUrlCDN(urlCdn));
    }, []);

    useEffect(() => {
        const checkSessionLogin = async () => {
            try {
                if (isLogged) {
                    const { data } = await authApi.getUserInfo();
                    if (!data.msg) {
                        dispatch(cacheUserInfo(data));
                    } else {
                        dispatch(logout(false));
                    }
                }
            } catch (error) {
                console.log(error);
            }
        };
        checkSessionLogin();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        /**
         * redirect if a mobile or tablet device
         */
        const redirectToWap = () => {
            if (isMobile) {
                const { protocol, host, pathname } = window.location;
                let link = `${protocol}//m.${host}`;
                if (pathname.includes('/reg')) {
                    link = `${link}${pathname}`;
                    console.log(link);
                }
                window.location.replace(link);
            }
        };
        redirectToWap();
    }, []);

    useEffect(() => {
        document.addEventListener('visibilitychange', () => {
            stopRequestUserInfo.current = document.hidden;
            if (!document.hidden) {
                timeoutId && clearTimeout(timeoutId);
                getUserInfo();
            }
        });
        return () => {
            document.removeEventListener('visibilitychange', () => {});
        };
    }, []);

    useEffect(() => {
        isLoggedRef.current = isLogged;
    }, [isLogged]);

    const getUserInfo = async () => {
        if (isLoggedRef.current) {
            try {
                const { data } = await authApi.getUserInfo();
                if (!data.code) {
                    dispatch(cacheUserInfo(data));
                } else {
                    alertMsg('Vui lòng đăng nhập lại !');
                    localStorage.removeItem('token');
                    dispatch(cacheUserInfo({} as UserInfoModel));
                    dispatch(login(false));
                }
            } catch (error) {
                timeoutId && clearTimeout(timeoutId);
                console.log(error);
            } finally {
                timeoutId && clearTimeout(timeoutId);
                timeoutId = setTimeout(() => {
                    if (!stopRequestUserInfo.current && isLoggedRef.current) {
                        getUserInfo();
                    }
                }, 10000);
            }
        }
    };

    return (
        <>
            <div className={styles.root} ref={rootDivRef} id="appRoot">
                <Routes>
                    {mainRoutes.map((route, index) => {
                        const Page = route.page;
                        return <Route key={index} path={route.path} element={<MainLayout>{route.isPrivate ? <PrivateRoute component={route.page} /> : <Page />}</MainLayout>} />;
                    })}
                    <Route path="/reg/:id" element={<Register />} />
                    <Route path="/reg" element={<Register />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>

                <MiniGameIcon />
                {/* support block */}
                <SupportArea ref={rootDivRef} />
            </div>
            <ToastRoot />
            <MessageAlertCustom />
        </>
    );
};
export default App;
